// extracted by mini-css-extract-plugin
export default {"root":"IconFullScreen_root__7tTpE"};